import { render, staticRenderFns } from "./TreatmentCreatedTimelineSection.vue?vue&type=template&id=268de20e&scoped=true"
import script from "./TreatmentCreatedTimelineSection.vue?vue&type=script&lang=js"
export * from "./TreatmentCreatedTimelineSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCreatedTimelineSection.vue?vue&type=style&index=0&id=268de20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268de20e",
  null
  
)

export default component.exports